// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-540b0b36]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.news-part[data-v-540b0b36] {\n  width: 1280px;\n  height: 500px;\n  margin: 0 auto;\n}\n.news-part .title[data-v-540b0b36] {\n  padding-top: 60px;\n}\n.news-part_wrapper[data-v-540b0b36] {\n  margin: 52px 0 85px;\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);
// Exports
module.exports = exports;
